module.exports = __webpack_public_path__ + "static/img/title-short.e8ed460.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/title-short.svg
// module id = nNwL
// module chunks = 0